import React from 'react';
import PropTypes from 'prop-types';
import UserAvatar from '../Avatars/UserAvatar';
import FollowButton from '../Buttons/FollowButton';
import { truncateString } from "../../../utils/stringConversion";

const UserCard = ({ user, doIFollow, onFollowClick, loggedInUser }) => (
  <div className="user-card">
    <div className="user-card-header">
      <a href={`/user/${user.id}`}>
        <UserAvatar image={user.image_url} size="l" verified={user.the_real_deal} />
      </a>
      {loggedInUser.computed_access &&
        <FollowButton userId={user.id} doIFollow={doIFollow} onClick={onFollowClick} />
      }
    </div>

    <a className="user-card-name h3 dark-link fw-medium" href={`/user/${user.id}`}>{user.full_name}</a>

    {user.bio &&
      <p className="user-card-bio h5 text-grey">{truncateString(user.bio, 250)}</p>
    }
  </div>
);

UserCard.propTypes = {
  user: PropTypes.object.isRequired,
  doIFollow: PropTypes.array,
  onFollowClick: PropTypes.func,
  loggedInUser: PropTypes.object,
};

export default UserCard;



// WEBPACK FOOTER //
// ./library/app/components/Global/Teasers/UserCard.js